import { render, staticRenderFns } from "./SwitchProduct.vue?vue&type=template&id=48e9c930&scoped=true&"
import script from "./SwitchProduct.vue?vue&type=script&lang=js&"
export * from "./SwitchProduct.vue?vue&type=script&lang=js&"
import style0 from "./SwitchProduct.vue?vue&type=style&index=0&id=48e9c930&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e9c930",
  null
  
)

export default component.exports